export const getBrowserTimezone = () => {
  let browserTimezone;
  try {
    browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;   
  } catch (error) {
    browserTimezone = 'UTC';
  }
  return browserTimezone;
}